import React from "react"
import { Influencer, SocialAccount } from "types/influencer"
import userProfilePicture from "../../assets/images/users/user-dummy-img.jpg"
interface SocialAccountHeaderProps {
    socialAccount: SocialAccount
    headerRightContent?: string | React.ReactNode,
    borderBottom?: boolean,
    language?: string,
    padding?: string,
    hideAdditionalInfo?: boolean
}
const SocialAccountHeader: React.FC<SocialAccountHeaderProps> = ({ socialAccount, language, borderBottom = true, headerRightContent, padding = 'p-2', hideAdditionalInfo = false }) => {
    return (
        <div className={`d-flex gap-3 ${padding} ${borderBottom && 'border-bottom-1'} justify-content-between influencer-profile-header`}>
            <div className={`d-flex gap-3 ${headerRightContent ? 'w-85' : 'w-100'}`}>
                <div className="position-relative">
                    <img src={socialAccount?.profile_picture_url ?? userProfilePicture} className="inf-profile-pic" />
                    {
                        socialAccount?.platform === 'ig' &&
                        <div className="ig-logo-space">
                            <div className="ig-logo"></div>
                        </div>
                    }
                    {
                        socialAccount?.platform === 'yt' &&
                        <div className="ig-logo-space">
                            <i className="ri-youtube-fill fs-16px text-danger"></i>
                        </div>
                    }
                </div>
                <div className="d-flex flex-column gap-1 justify-content-center w-100 overflow-hidden">
                    <span className="inf-name text-truncate w-100">
                        {
                            socialAccount?.platform === 'ig' && socialAccount?.ig?.name
                        }
                        {
                            socialAccount?.platform === 'yt' && (socialAccount?.yt?.title ?? socialAccount?.yt?.username) 
                        }
                    </span>
                    <span className="inf-location text-truncate w-100">@{socialAccount?.handle}</span>
                    {
                        !hideAdditionalInfo &&
                        <div className="d-flex align-items-center gap-2">
                            {/* <span className="badge language-badge">{influencer.gender_name}</span> */}
                            {
                                language &&
                                <span className="badge language-badge">{language}</span>
                            }
                        </div>
                    }
                </div>
            </div>
            {headerRightContent}
        </div>
    )
}

export default SocialAccountHeader